import { Button } from '@mui/material';
import { useAtomValue, useSetAtom } from 'jotai';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { TaskAction } from '@kheops/graphql';
import OrderBuyerReceptionDialog from '../dialogs/OrderBuyerReceptionDialog';
import useOpenable from '../../../hooks/useOpenable';
import { areOrderItemsEditedAtom, editedOrderItemsAtom, orderAtom } from '../../state/state';
import useOrderActions from '../../../hooks/useOrderActions';

export default function OrderBuyerReceptionButton(): React.JSX.Element {
  const { t } = useTranslation(['order']);
  const order = useAtomValue(orderAtom);
  const areItemsEdited = useAtomValue(areOrderItemsEditedAtom);
  const setEditedItems = useSetAtom(editedOrderItemsAtom);
  const { updateOrder, isLoading } = useOrderActions({ orderReferenceId: order.reference_id, orderId: order.id });
  const { open, isOpen, close } = useOpenable();

  const handleClose = useCallback((confirmed: boolean) => {
    if (!confirmed) {
      if (areItemsEdited) {
        setEditedItems();
      }
    } else {
      updateOrder(TaskAction.Approve);
    }

    close();
  }, [areItemsEdited, updateOrder]);

  return (
    <>
      <OrderBuyerReceptionDialog open={isOpen} onClose={handleClose} />
      <Button
        variant="outlined"
        color="tertiary"
        onClick={open}
        loading={isLoading}
      >
        {t('order:receive_order')}
      </Button>
    </>
  );
}
